<template>
  <div class="register">
    <vue-particles
      color="#0a5571"
      :particleOpacity="0.7"
      :particlesNumber="80"
      shapeType="circle"
      :particleSize="4"
      linesColor="#0a5571"
      :linesWidth="1"
      :lineLinked="true"
      :lineOpacity="0.4"
      :linesDistance="150"
      :moveSpeed="3"
      :hoverEffect="true"
      hoverMode="grab"
      :clickEffect="false"
      style="width: 100vw; height: 100vh"
    ></vue-particles>
    <div class="content">
      <a-tabs defaultActiveKey="1" @change="callback">
        <a-tab-pane :tab="$tc('lang.Register.Mobile_phone')" key="1">
          <a-form :form="form" @submit="handleSubmit">
            <a-form-item>
              <a-input
                size="large"
                :placeholder="$tc('lang.Register.phone_Number_text')"
                v-decorator="[
                  'name',
                  {
                    rules: [
                      {
                        required: true,
                        message: $tc('lang.Register.phone_Number_text'),
                      },
                    ],
                  },
                ]"
              >
                <a-icon
                  slot="prefix"
                  type="user"
                  style="color: rgba(0, 0, 0, 0.25)"
                />
              </a-input>
            </a-form-item>
            <a-form-item>
              <a-input-group compact>
                <a-input
                  size="large"
                  style="width: 65%"
                  :placeholder="$tc('lang.Register.verification_code')"
                  v-decorator="[
                    'number',
                    {
                      rules: [
                        {
                          required: true,
                          message: $tc('lang.Register.verification_code'),
                        },
                      ],
                    },
                  ]"
                >
                  <a-icon
                    slot="prefix"
                    type="user"
                    style="color: rgba(0, 0, 0, 0.25)"
                  />
                </a-input>
                <a-button
                  size="large"
                  style="font-size: 12px; width: 35%; font-size: 16px"
                  :disabled="
                    code == $tc('lang.Register.Get_Verified') ? false : true
                  "
                  @click="getCode"
                  >{{ code }}</a-button
                >
              </a-input-group>
            </a-form-item>
            <a-form-item>
              <a-input
                size="large"
                 v-show="show==1"
                type="password"
                :placeholder="$tc('lang.Register.Please_password')"
                v-decorator="[
                  'passWord',
                  {
                    rules: [
                      {
                        required: true,
                        message: $tc('lang.Register.Please_password'),
                      },
                    ],
                  },
                ]"
              >
                <a-icon
                  slot="prefix"
                  type="lock"
                  style="color: rgba(0, 0, 0, 0.25)"
                />
                <a-icon slot="suffix"   type="eye-invisible"
                style="color:rgba(0,0,0,.25)" @click="show=2"/>
              </a-input>
              <a-input
                size="large"
                 v-show="show==2"
                type="text"
                :placeholder="$tc('lang.Register.Please_password')"
                v-decorator="[
                  'passWord',
                  {
                    rules: [
                      {
                        required: true,
                        message: $tc('lang.Register.Please_password'),
                      },
                    ],
                  },
                ]"
              >
                <a-icon
                  slot="prefix"
                  type="lock"
                  style="color: rgba(0, 0, 0, 0.25)"
                />
                <a-icon slot="suffix"   type="eye"
                style="color:rgba(0,0,0,.25)" @click="show=1"/>
              </a-input>
            </a-form-item>
            <a-form-item style="margin-bottom: 50px">
              <a-input
                size="large"
                v-show="cshow==1"
                type="password"
                :placeholder="$tc('lang.Register.Please_password')"
                v-decorator="[
                  'cpassWord',
                  {
                    rules: [
                      {
                        required: true,
                        message: $tc('lang.Register.Please_password'),
                      },
                    ],
                  },
                ]"
              >
                <a-icon
                  slot="prefix"
                  type="lock"
                  style="color: rgba(0, 0, 0, 0.25)"
                />
                <a-icon slot="suffix"   type="eye-invisible"
                style="color:rgba(0,0,0,.25)" @click="cshow=2"/>
              </a-input>
              <a-input
                size="large"
                v-show="cshow==2"
                type="text"
                :placeholder="$tc('lang.Register.Please_password')"
                v-decorator="[
                  'cpassWord',
                  {
                    rules: [
                      {
                        required: true,
                        message: $tc('lang.Register.Please_password'),
                      },
                    ],
                  },
                ]"
              >
                <a-icon
                  slot="prefix"
                  type="lock"
                  style="color: rgba(0, 0, 0, 0.25)"
                />
                <a-icon slot="suffix"   type="eye"
                style="color:rgba(0,0,0,.25)" @click="cshow=1"/>
              </a-input>
            </a-form-item>
            <a-form-item>
              <a-button
                type="primary"
                size="large"
                html-type="submit"
                class="button-pri"
              >
                {{ $tc('lang.Register.Register') }}
              </a-button>
            </a-form-item>
          </a-form>
        </a-tab-pane>
        <a-tab-pane :tab="$tc('lang.Register.E_mail')" key="2">
          <a-form :form="form1" @submit="handleSubmit1">
            <a-form-item style="margin-bottom: 50px">
              <a-input
                size="large"
                :placeholder="$tc('lang.Register.Please_ailbox')"
                v-decorator="[
                  'name',
                  {
                    rules: [
                      {
                        required: true,
                        message: $tc('lang.Register.Please_ailbox'),
                      },
                    ],
                  },
                ]"
              >
                <a-icon
                  slot="prefix"
                  type="user"
                  style="color: rgba(0, 0, 0, 0.25)"
                />
              </a-input>
            </a-form-item>
            <!--<a-form-item>
              <a-input-group compact>
                <a-input
                  size="large"
                  style="width: 65%"
                  :placeholder="$tc('lang.Register.verification_code')"
                  v-decorator="[
                    'number',
                    {
                      rules: [
                        {
                          required: true,
                          message: $tc('lang.Register.verification_code'),
                        },
                      ],
                    },
                  ]"
                >
                  <a-icon
                    slot="prefix"
                    type="lock"
                    style="color:rgba(0,0,0,.25)"
                  />
                </a-input>
                <a-button
                  size="large"
                  style="font-size: 12px;width: 35%;font-size: 16px;"
                  :disabled="
                    code1 == $tc('lang.Register.Get_Verified') ? false : true
                  "
                  @click="getCode1"
                  >{{ code1 }}</a-button
                >
              </a-input-group>
            </a-form-item>-->
            <a-form-item style="margin-bottom: 50px">
              <a-input
                size="large"
                 v-show="show==1"
                type="password"
                :placeholder="$tc('lang.Register.Please_password')"
                v-decorator="[
                  'passWord',
                  {
                    rules: [
                      {
                        required: true,
                        message: $tc('lang.Register.Please_password'),
                      },
                    ],
                  },
                ]"
              >
                <a-icon
                  slot="prefix"
                  type="lock"
                  style="color: rgba(0, 0, 0, 0.25)"
                />
                <a-icon slot="suffix"   type="eye-invisible"
                style="color:rgba(0,0,0,.25)" @click="show=2"/>
              </a-input>
              <a-input
                size="large"
                 v-show="show==2"
                type="text"
                :placeholder="$tc('lang.Register.Please_password')"
                v-decorator="[
                  'passWord',
                  {
                    rules: [
                      {
                        required: true,
                        message: $tc('lang.Register.Please_password'),
                      },
                    ],
                  },
                ]"
              >
                <a-icon
                  slot="prefix"
                  type="lock"
                  style="color: rgba(0, 0, 0, 0.25)"
                />
                <a-icon slot="suffix"   type="eye"
                style="color:rgba(0,0,0,.25)" @click="show=1"/>
              </a-input>
            </a-form-item>
            <a-form-item style="margin-bottom: 50px">
              <a-input
                size="large"
                v-show="cshow==1"
                type="password"
                :placeholder="$tc('lang.Register.Please_password')"
                v-decorator="[
                  'cpassWord',
                  {
                    rules: [
                      {
                        required: true,
                        message: $tc('lang.Register.Please_password'),
                      },
                    ],
                  },
                ]"
              >
                <a-icon
                  slot="prefix"
                  type="lock"
                  style="color: rgba(0, 0, 0, 0.25)"
                />
                <a-icon slot="suffix"   type="eye-invisible"
                style="color:rgba(0,0,0,.25)" @click="cshow=2"/>
              </a-input>
              <a-input
                size="large"
                v-show="cshow==2"
                type="text"
                :placeholder="$tc('lang.Register.Please_password')"
                v-decorator="[
                  'cpassWord',
                  {
                    rules: [
                      {
                        required: true,
                        message: $tc('lang.Register.Please_password'),
                      },
                    ],
                  },
                ]"
              >
                <a-icon
                  slot="prefix"
                  type="lock"
                  style="color: rgba(0, 0, 0, 0.25)"
                />
                <a-icon slot="suffix"   type="eye"
                style="color:rgba(0,0,0,.25)" @click="cshow=1"/>
              </a-input>
            </a-form-item>
            <a-form-item>
              <a-button
                size="large"
                type="primary"
                html-tpe="submit"
                @click="handleSubmit1"
                class="button-pri"
              >
                {{ $tc('lang.Register.Register') }}
              </a-button>
            </a-form-item>
          </a-form>
        </a-tab-pane>
      </a-tabs>

      <div class="bottom">
        <router-link to="/login">{{ $tc('lang.Login.Log_in') }}</router-link>
        <router-link to="/home">{{ $tc('lang.Login.Home_page') }}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: this.$form.createForm(this),
      form1: this.$form.createForm(this),
      code: this.$tc('lang.Register.Get_Verified'),
      code1: this.$tc('lang.Register.Get_Verified'),
      show:1,
      cshow: 1,
    };
  },
  methods: {
    callback(key) {
      this.key = key;
      this.show=1
      this.cshow=1

    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          if( values.passWord !== values.cpassWord){

            this.$message.error('两次密码不一致');
            return
        }     
          this.$http
            .post('/hzwmj/person/register', {
              personMobilephone: values.name,
              personPassword: values.passWord,
              personEmail: '',
              captcha: values.number,
              personType: '3',
            })
            .then((data) => {
              if (data.data == '用户注册成功') {
                this.$message.success('用户注册成功');
                this.$router.push('/home');
              } else {
                this.$message.error(data.data);
              }
            })
            .catch(() => {
              this.$message.error('注册失败');
            });
          // console.log('Received values of form: ', values);
        }
      });
    },
    handleSubmit1(e) {
      e.preventDefault();
      this.form1.validateFields((err, values) => {
        if (!err) {
          this.$http
            .post('/hzwmj/person/register', {
              personMobilephone: '',
              personPassword: values.passWord,
              personEmail: values.name,
              captcha: values.number,
              personType: '3',
            })
            .then((data) => {
              if (data.data == '用户注册成功') {
                this.$message.success('用户注册成功');
                this.$router.push('/home');
              } else {
                this.$message.error(data.data);
              }
            })
            .catch(() => {
              this.$message.error('注册失败');
            });
        }
      });
    },
    //手机获取验证码
    getCode() {
      this.form.validateFields(['name'], (err, values) => {
        if (!err) {
          this.$http
            .post('/hzwmj/sendsms/sendMessage', {
              receiver: values.name,
            })
            .then((data) => {
              if (data) {
                console.log(data);
              } else {
                this.$message.error('获取失败');
              }
            })
            .catch(() => {
              this.$message.error('获取失败');
            });
        }
      });
      let time = 60;
      this.code = `${time}s`;
      let _this = this;
      let setTime = setInterval(function () {
        time--;
        _this.code = `${time}s`;
        if (time == 0) {
          _this.code = '获取验证码';
          clearInterval(setTime);
        }
      }, 1000);
    },
    // 邮箱获取验证码
    getCode1() {
      this.form1.validateFields(['name'], (err, values) => {
        if (!err) {
          this.$http
            .post('/hzwmj/mail/sendMail', {
              receiver: values.name,
            })
            .then((data) => {
              if (data) {
                console.log(data);
              } else {
                this.$message.error('获取失败');
              }
            })
            .catch(() => {
              this.$message.error('获取失败');
            });
        }
      });
      let time = 60;
      this.code1 = `${time}s`;
      let _this = this;
      let setTime = setInterval(function () {
        time--;
        _this.code1 = `${time}s`;
        if (time == 0) {
          _this.code1 = '获取验证码';
          clearInterval(setTime);
        }
      }, 1000);
    },
  },
};
</script>

<style lang="less">
.register {
  height: 100vh;
  background-image: url(./image/banner3.png);
  background-repeat: no-repeat;
  background-size: 100vw 100vh;
  font-size: 16px;
  .ant-tabs-bar {
    margin-bottom: 24px;
    .ant-tabs-nav-container {
      font-size: 16px;
      color: #fff;
    }
  }
  .content {
    width: 420px;
    height: 500px;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    padding: 20px 40px 40px;
    /*background-color: #fff;*/
    background-color: rgba(255, 255, 255, 0.4);
    border-radius: 10px;
    .ant-form-item {
      margin-bottom: 28px;
    }
  }
  .ant-form-explain {
    text-align: left;
  }
  p {
    font-size: 16px;
    color: #1696ff;
    margin: 30px 0;
  }
  .button-pri {
    width: 100%;
  }
  .bottom {
    display: flex;
    justify-content: space-between;
    a {
      // color: rgba(0, 0, 0, 0.25);
      color: #fff;
    }
  }
}
</style>
